// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, {PropTypes, Component} from 'react';
import { connect } from 'react-redux';

// utilities
import _ from 'lodash';

// redux interactions
import * as companyApi from '../../../../../redux/actionCreators/async/companies';
import * as adminStore from '../../../../../redux/actionCreators/sync/index';

// components
import Search from '../../../../../common/components/Search';
import CompaniesTable from './CompaniesTable';

@connect((state, props) => {
  return {
    staticData: state.staticData,
    companies: state.admin.companies.items,
    total: state.admin.companies.total,
    filters: state.admin.companies.filters || {},
    searchTerms: state.admin.companies.searchTerms || [],
    labels: _.get(state, 'labels.CompanyDashboard', {}),
  };
})
export default class CompanyManager extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    companies: PropTypes.any,
    total: PropTypes.any,
    staticData: PropTypes.object,
    searchCompanies: PropTypes.func,
    filters: PropTypes.object,
    searchTerms: PropTypes.array,
    labels: PropTypes.object,
  }

  static defaultProps = {
    companies: {}
  }

  constructor(props) {
    super(props);
    this.state = {
      currentPage: 0,
      pageSize: 25,
    };
  }

  componentDidMount() {
    this.props.searchCompanies(this.props.searchTerms, this.props.filters);
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.filters, this.props.filters) || !_.isEqual(prevProps.searchTerms, this.props.searchTerms)) {
      this.onPageChange(this.state.currentPage);
    }
  }

  onPageChange(page) {
    const skip = page * this.state.pageSize;
    const terms = this.props.searchTerms || [];
    const filters = this.props.filters || {};

    this.props.dispatch(companyApi.goToPage(skip, this.state.pageSize, terms, filters));
    this.setState({currentPage: page});
  }

  onTermChange(terms =[]) {
    this.setState({currentPage: 0}, () =>
      this.props.dispatch(adminStore.updateCompaniesTableSearchTerms(terms))
    );
  }

  onFilterChange(filterName) {
    return (event, key) => {

      // get current filters
      let newFilters = _.cloneDeep(this.props.filters) || {};

      // set new filters
      if (key < 0) {
        newFilters = _.omit(newFilters, filterName);
      }
      else {
        _.set(newFilters, filterName, key || _.get(event, 'target.value') || 0);
      }

      // dispatch action to update filters in companies store
      this.setState({currentPage: 0}, () =>
        this.props.dispatch(adminStore.updateCompaniesTableFilters(newFilters))
      );
    };
  }

  onSortChange(newSortFilters) {
    const newFilters = _.cloneDeep(this.props.filters) || {};
    const sortFilters = _.merge({}, newFilters, newSortFilters);
    this.props.dispatch(adminStore.updateCompaniesTableFilters(sortFilters));
  }

  render() {
    return (
      <ul className='applicant-manager columns-container companies-dasboard-manager'>
        <div className='companies-table-header'>
          <h3 className='title'>Companies</h3>
          <Search
            onTermChange={::this.onTermChange}
            baseUrl='/admin/companies'
            defaultValues={this.props.searchTerms}
          />
        </div>
        <CompaniesTable
          staticData={this.props.staticData}
          companies={this.props.companies}
          dispatch={this.props.dispatch}
          total={this.props.total}
          currentPage={this.state.currentPage}
          pageSize={this.state.pageSize}
          onPageChange={::this.onPageChange}
          onFilterChange={::this.onFilterChange}
          onSortChange={::this.onSortChange}
          filters={this.props.filters}
          labels={this.props.labels.companyTable}
        />
      </ul>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/Company/Dashboard/CompanyManager/index.js